import type { CatalogSnapshot } from "./model";

export const DEFAULT_CATALOG: CatalogSnapshot = {
  currency: "MXN",
  locale: "es-MX",
  verifiedAt: "2026-07-30",
  services: [
    {
      id: "spotify",
      name: "Spotify Premium",
      shortName: "Spotify",
      category: "musica",
      plan: "Individual",
      monthlyPriceCents: 13_900,
      sourceUrl: "https://www.spotify.com/mx/premium/",
      verifiedAt: "2026-07-30",
      glyph: "SP",
    },
    {
      id: "apple-music",
      name: "Apple Music",
      shortName: "Apple Music",
      category: "musica",
      plan: "Individual",
      monthlyPriceCents: 13_900,
      sourceUrl: "https://www.apple.com/mx/apple-music/",
      verifiedAt: "2026-07-30",
      glyph: "AM",
    },
    {
      id: "youtube-premium",
      name: "YouTube Premium",
      shortName: "YouTube",
      category: "video",
      plan: "Individual",
      monthlyPriceCents: 15_900,
      sourceUrl: "https://www.youtube.com/premium",
      verifiedAt: "2026-07-30",
      glyph: "YT",
    },
    {
      id: "netflix",
      name: "Netflix",
      shortName: "Netflix",
      category: "video",
      plan: "Estándar",
      monthlyPriceCents: 26_900,
      sourceUrl: "https://www.netflix.com/mx/",
      verifiedAt: "2026-07-30",
      glyph: "NF",
    },
    {
      id: "disney-plus",
      name: "Disney+",
      shortName: "Disney+",
      category: "video",
      plan: "Estándar · promoción por 6 meses",
      monthlyPriceCents: 19_900,
      sourceUrl: "https://www.disneyplus.com/es-mx",
      verifiedAt: "2026-07-30",
      glyph: "D+",
    },
    {
      id: "amazon-prime",
      name: "Amazon Prime",
      shortName: "Prime",
      category: "video",
      plan: "Membresía mensual",
      monthlyPriceCents: 9_900,
      sourceUrl: "https://www.amazon.com.mx/prime",
      verifiedAt: "2026-07-30",
      glyph: "PR",
    },
    {
      id: "max",
      name: "HBO Max",
      shortName: "HBO Max",
      category: "video",
      plan: "Estándar",
      monthlyPriceCents: 23_900,
      sourceUrl: "https://www.max.com/mx/es",
      verifiedAt: "2026-07-30",
      glyph: "MX",
    },
    {
      id: "google-one",
      name: "Google One",
      shortName: "Google One",
      category: "nube",
      plan: "200 GB",
      monthlyPriceCents: 4_900,
      sourceUrl: "https://one.google.com/about/plans?hl=es-mx",
      verifiedAt: "2026-07-30",
      glyph: "G1",
    },
    {
      id: "icloud",
      name: "iCloud+",
      shortName: "iCloud+",
      category: "nube",
      plan: "200 GB",
      monthlyPriceCents: 4_900,
      sourceUrl: "https://www.apple.com/mx/icloud/",
      verifiedAt: "2026-07-30",
      glyph: "IC",
    },
    {
      id: "notion",
      name: "Notion",
      shortName: "Notion",
      category: "productividad",
      plan: "Plus · mensual · referencia USD convertida",
      monthlyPriceCents: 20_900,
      sourceUrl: "https://www.notion.com/es/pricing",
      verifiedAt: "2026-07-30",
      glyph: "NO",
    },
    {
      id: "xbox-game-pass",
      name: "Xbox Game Pass",
      shortName: "Game Pass",
      category: "juegos",
      plan: "Premium",
      monthlyPriceCents: 21_900,
      sourceUrl: "https://www.xbox.com/es-MX/xbox-game-pass",
      verifiedAt: "2026-07-30",
      glyph: "XB",
    },
    {
      id: "playstation-plus",
      name: "PlayStation Plus",
      shortName: "PS Plus",
      category: "juegos",
      plan: "Extra · referencia mensual",
      monthlyPriceCents: 27_900,
      sourceUrl: "https://www.playstation.com/es-mx/ps-plus/",
      verifiedAt: "2026-07-30",
      glyph: "PS",
    },
  ],
};
